module.exports = __webpack_public_path__ + "static/screen-01-8903f6c9331315bbcc080d9ab53c2562.jpg";